















































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import BookkeepingSetup from './BookkeepingSetup.vue';
import gql from 'graphql-tag';

const ALL_FB_BOOKKEEPING_ACCOUNTS = gql`
  query fbBookkeepingAccounts($unitId: ID!) {
    fbBookkeepingAccounts(unitId: $unitId) {
      name
      number
    }
  }
`;

const SAVE_AMELDING_ACCOUNT_SELECTIONS = gql`
  mutation saveAmeldingAccountSelections(
    $unitId: ID!,
    $ameldingAccountSelections: [AmeldingAccountSelectionSave!]!
  ) {
    saveAmeldingAccountSelections(input: {
      unitId: $unitId,
      ameldingAccountSelections: $ameldingAccountSelections,
    }) {
      unit {
        id
        ameldingAccountSelections {
          id number employeeTaxDeduction
        }
      }
    }
  }
`;


@Component({
  components: {
    BookkeepingSetup,
  },
})
export default class BookkeepingSetupButton extends Vue {
  private ALL_FB_BOOKKEEPING_ACCOUNTS = ALL_FB_BOOKKEEPING_ACCOUNTS;

  @Prop({ required: true }) private currentUnit!: GQL_currentUnit_currentUnit;

  private showDialog = false;
  @Ref() private formRef?: BookkeepingSetup;

  private translate(key: string) {
    return this.$t(`PaycheckReport.AmeldingAndBookkeepingReconciliation.Bookkept.${key}`);
  }

  private save() {
    if (!this.formRef) { return }

    const data = this.formRef.serializeAccounts();

    this.$apollo.mutate({
      mutation: SAVE_AMELDING_ACCOUNT_SELECTIONS,
      variables: {
        unitId: this.currentUnit.id,
        ameldingAccountSelections: data,
      },
    }).then(() => {
      this.$emit('updated-config');
    });
  }
}
